import { render, staticRenderFns } from "./NewPriceList.vue?vue&type=template&id=76ed1a34&scoped=true"
import script from "./NewPriceList.vue?vue&type=script&lang=js"
export * from "./NewPriceList.vue?vue&type=script&lang=js"
import style0 from "./NewPriceList.vue?vue&type=style&index=0&id=76ed1a34&prod&lang=scss&scoped=true"
import style1 from "./NewPriceList.vue?vue&type=style&index=1&id=76ed1a34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ed1a34",
  null
  
)

export default component.exports